import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const createRule=(statement,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.CREATE_RULE_START
    })
    const options={
        url:`${api}/rules`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{statement}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CREATE_RULE_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CREATE_RULE_FAIL,
                payload:getMessage(error)
            }))
}